import { httpClient } from './http';
import { Waiter, CreateWaiterData, UpdateWaiterData, TableAssignment } from '../types';

const BASE_URL = '/system';

export const adminWaitersService = {
  // Obtener todos los meseros de un restaurante
  async getWaiters(userId: string, restaurantId: string): Promise<Waiter[]> {
    try {
      const response = await httpClient.get<Waiter[]>(`${BASE_URL}/users/${userId}/restaurants/${restaurantId}/waiters`, {}, 'authenticated');
      
      console.log('🔍 Respuesta del backend:', response);
      
      // Si la respuesta es un objeto con data, extraer el array
      if (response && typeof response === 'object' && !Array.isArray(response) && 'data' in response) {
        const data = (response as any).data || [];
        console.log('📦 Datos extraídos del objeto:', data);
        return data;
      }
      
      const result = Array.isArray(response) ? response : [];
      console.log('📋 Resultado final:', result);
      return result;
    } catch (error) {
      console.error('❌ Error obteniendo meseros:', error);
      throw error;
    }
  },

  // Crear un nuevo mesero
  async createWaiter(userId: string, waiterData: CreateWaiterData): Promise<Waiter> {
    try {
      console.log('👤 Creando mesero:', waiterData);
      const response = await httpClient.post<Waiter>(`${BASE_URL}/users/${userId}/restaurants/${waiterData.restaurantId}/waiters`, waiterData, 'authenticated');
      console.log('✅ Mesero creado exitosamente:', response);
      return response;
    } catch (error) {
      console.error('❌ Error creando mesero:', error);
      throw error;
    }
  },

  // Actualizar un mesero
  async updateWaiter(userId: string, restaurantId: string, waiterId: string, waiterData: UpdateWaiterData): Promise<Waiter> {
    try {
      console.log('✏️ Actualizando mesero:', waiterId, waiterData);
      const response = await httpClient.put<Waiter>(`${BASE_URL}/users/${userId}/restaurants/${restaurantId}/waiters/${waiterId}`, waiterData, 'authenticated');
      console.log('✅ Mesero actualizado exitosamente:', response);
      return response;
    } catch (error) {
      console.error('❌ Error actualizando mesero:', error);
      throw error;
    }
  },

  // Eliminar un mesero (si aplica)
  async deleteWaiter(userId: string, restaurantId: string, waiterId: string): Promise<void> {
    try {
      console.log('🗑️ Eliminando mesero:', waiterId);
      await httpClient.delete(`${BASE_URL}/users/${userId}/restaurants/${restaurantId}/waiters/${waiterId}`, 'authenticated');
      console.log('✅ Mesero eliminado exitosamente');
    } catch (error) {
      console.error('❌ Error eliminando mesero:', error);
      throw error;
    }
  },

  // Asignar mesas a un mesero
  async assignTables(userId: string, restaurantId: string, assignment: TableAssignment): Promise<void> {
    try {
      console.log('🪑 Asignando mesas a mesero:', assignment);
      await httpClient.post(`${BASE_URL}/users/${userId}/restaurants/${restaurantId}/waiters/${assignment.waiterId}/tables`, 
        { tableIds: assignment.tableIds }, 'authenticated');
      console.log('✅ Mesas asignadas exitosamente');
    } catch (error) {
      console.error('❌ Error asignando mesas:', error);
      throw error;
    }
  },

  // Obtener mesas asignadas a un mesero
  async getWaiterTables(userId: string, restaurantId: string, waiterId: string): Promise<string[]> {
    try {
      console.log('🪑 Obteniendo mesas del mesero:', waiterId);
      const response = await httpClient.get<string[]>(`${BASE_URL}/users/${userId}/restaurants/${restaurantId}/waiters/${waiterId}/tables`, {}, 'authenticated');
      console.log('✅ Mesas del mesero obtenidas:', response);
      return Array.isArray(response) ? response : [];
    } catch (error) {
      console.error('❌ Error obteniendo mesas del mesero:', error);
      throw error;
    }
  }
}; 